__turbopack_context__.v({
  "className": "qPq4ha_className",
  "variable": "qPq4ha_variable",
});
